import { render, staticRenderFns } from "./UserHistoryController.vue?vue&type=template&id=4668435b"
import script from "./UserHistoryController.vue?vue&type=script&lang=js"
export * from "./UserHistoryController.vue?vue&type=script&lang=js"
import style0 from "./UserHistoryController.vue?vue&type=style&index=0&id=4668435b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports